import { useDeviceType } from '@cian/ui-kit';

import { SearchTextInputContainer } from './SearchTextInputContainer';
import { SearchTextButtonContainer } from './SearchTextButtonContainer';

export function SearchTextLayout() {
  const deviceType = useDeviceType();

  return deviceType === 'desktop' ? <SearchTextInputContainer /> : <SearchTextButtonContainer />;
}
